import { render, staticRenderFns } from "./TaskInfoDialog.vue?vue&type=template&id=104d9a4e&scoped=true"
import script from "./TaskInfoDialog.vue?vue&type=script&lang=ts"
export * from "./TaskInfoDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104d9a4e",
  null
  
)

export default component.exports